import * as React from 'react'
import Input from '@material-ui/core/Input'
import FormHelperText from '@material-ui/core/FormHelperText'
import { IControlProps } from './types'
import { GRID_CELLPADDING, GRID_CELLFONTSIZE } from './grids/consts'
import { InputBaseComponentProps } from '@material-ui/core/InputBase'
import { TEXT_MAX_LENGTH } from './constants'

export default class TextControl extends React.Component<IControlProps> {
  constructor(props: any) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event: any): void {
    this.props.form.setFieldValue(this.props.field.name, event.target.value)
  }

  render(): React.ReactNode {
    const limit = this.props.maxLength ?? TEXT_MAX_LENGTH
    const currentLength = ((this.props.field.value as string) || '').length
    const inputProps: InputBaseComponentProps = { maxLength: limit }
    if (this.props.gridCell) {
      return (
        <div
          id={this.props.id}
          style={{ padding: GRID_CELLPADDING, fontSize: GRID_CELLFONTSIZE }}
        >
          {this.props.field.value || ''}
        </div>
      )
    } else {
      // Render Input + helper text as siblings (via Fragment, no wrapping
      // div) so the Input remains a direct flex child of any enclosing
      // FormControl. Wrapping in a <div> broke MUI's label/Input layout
      // when used through FormikField, which mounts the Input inside a
      // FormControl + InputLabel and relies on the Input being a direct
      // flex child for the 16px label gap.
      return (
        <>
          <Input
            id={this.props.id}
            fullWidth
            value={this.props.field.value || ''}
            onChange={this.handleChange}
            disabled={this.props.disabled}
            placeholder={this.props.placeholder || ''}
            inputProps={inputProps}
          />
          <FormHelperText
            style={{
              textAlign: 'right',
              color: currentLength >= limit ? 'red' : undefined
            }}
          >
            {currentLength} / {limit}
            {currentLength >= limit && ' — Character limit reached'}
          </FormHelperText>
        </>
      )
    }
  }
}
